"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keycode = _interopRequireDefault(require("keycode"));
var _attach = require("@catalytic/catalytic-icons/lib/glyphs/attach.svg");
var _error = require("@catalytic/catalytic-icons/lib/icons/error.svg");
var _mixins = _interopRequireDefault(require("../../style/mixins"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _excluded = ["accept", "autoFocus", "classes", "className", "defaultValue", "disabled", "disabledClassName", "displayErrors", "embedded", "filename", "files", "hasError", "hasRequired", "hasSuccess", "hasValidation", "inputClassName", "inputRef", "intl", "loading", "maxFileSize", "multiple", "name", "onBlur", "onChange", "placeholder", "readOnly", "readOnlyClassName", "required", "setDisplayErrorsState", "setLoadingState", "theme", "title", "type", "url"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ComponentType, type ElementRef } from 'react';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var FILES_DEFAULT_VALUE = [];
var DISPLAY_NAME = 'FileInput';
var NOOP = function NOOP() {};
var INDEX = 0;
var messages = {
  loading: {
    defaultMessage: 'Loading...',
    description: 'File input loading',
    id: 'file.loading'
  }
};
var definedMessages = (0, _reactIntl.defineMessages)(messages);
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      position: 'relative'
    },
    input: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.inputMultiPadding), {}, {
      paddingLeft: '2.5rem',
      '&:required:valid': {
        '& ~ $required': {
          display: 'none'
        }
      }
    }),
    inputFocus: theme.mixins.inputFocus,
    inputShadow: {
      display: 'none'
    },
    placeholder: _objectSpread(_objectSpread({}, theme.mixins.inputPlaceholder), {}, {
      margin: '.438rem 0 .438rem .25rem',
      cursor: 'default',
      // not-allowed
      pointerEvents: 'none',
      userSelect: 'none'
    }),
    success: theme.mixins.inputSuccess,
    error: _objectSpread(_objectSpread({}, theme.mixins.inputError), {}, {
      paddingRight: '2.875rem'
    }),
    errorMessage: theme.mixins.inputInlineErrorMessage,
    errorIcon: theme.mixins.inputInlineErrorIcon,
    required: {},
    disabled: {
      '&, &:focus, &:hover': theme.mixins.inputDisabled,
      '& $label': theme.mixins.inputMultiLabelDisabled,
      '& $remove': {
        '&, &:focus, &:hover': theme.mixins.inputMultiRemoveDisabled
      }
    },
    readOnly: {
      '& $label': {
        color: theme.colors.black,
        pointerEvents: 'auto',
        '&:active, &:hover': {
          color: theme.colors.pebbleGrey
        }
      },
      '& $remove': {
        display: 'none'
      }
    },
    container: theme.mixins.inputContainer,
    value: theme.mixins.inputMultiValue,
    label: _objectSpread(_objectSpread({}, theme.mixins.inputMultiLabel), {}, {
      '&:active, &:hover': {
        color: theme.colors.pebbleGrey
      }
    }),
    remove: theme.mixins.inputMultiRemove,
    icon: _objectSpread(_objectSpread({}, theme.mixins.verticalAlign), {}, {
      left: '.563rem',
      color: theme.colors.battleshipGrey,
      fontSize: '1.875rem'
    }),
    embedded: {
      borderRadius: theme.variables.borderRadiusSmall,
      paddingLeft: '2rem',
      paddingTop: '0',
      paddingBottom: '0',
      '& svg': {
        fontSize: '1.6875rem',
        left: '0.25rem'
      }
    },
    embeddedContainer: {
      minHeight: '1.875rem'
    },
    embeddedItem: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      marginTop: 0,
      marginBottom: 0
    })
  };
};
/*:: type Files = Array<{
  id: string,
  name: string,
  value: any
}>;*/
/*:: export type FileInputType = InjectSheetProvidedProps &
  HTMLInputElement & {
    accept?: string,
    autoFocus: boolean,
    disabledClassName?: string,
    displayErrors: boolean,
    embedded?: boolean,
    filename: ?string,
    files?: Files,
    hasError: boolean,
    hasRequired: boolean,
    hasSuccess: boolean,
    hasValidation?: boolean,
    inputClassName?: string,
    inputRef?: ElementRef<*>,
    intl: Object,
    loading: boolean,
    maxFileSize?: number,
    onBlur?: ({
      currentTarget: { id: string, name: string, value: any }
    }) => mixed,
    onChange?: (
      {
        currentTarget: { id: string, name: string, value: any }
      },
      isAcceptable?: boolean
    ) => mixed,
    readOnlyClassName?: string,
    setDisplayErrorsState?: (displayErrors: boolean) => mixed,
    setLoadingState?: (loading: boolean) => mixed,
    url: ?string
  };*/
/*:: type State = {
  files: Files
};*/
var FileInput = /*#__PURE__*/function (_PureComponent) {
  function FileInput() {
    var _this;
    (0, _classCallCheck2.default)(this, FileInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FileInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      files: Array.isArray(_this.props.files) ? _this.props.files : FILES_DEFAULT_VALUE
    });
    (0, _defineProperty2.default)(_this, "_isMounted", false);
    (0, _defineProperty2.default)(_this, "handleChange", function (data /*: Array<any>*/, dataRejections /*: Array<any>*/) {
      var _this$props = _this.props,
        id = _this$props.id,
        multiple = _this$props.multiple,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var prevFiles = _this.state.files;
      var files = [].concat((0, _toConsumableArray2.default)(multiple ? prevFiles : FILES_DEFAULT_VALUE), (0, _toConsumableArray2.default)(data.map(function (file) {
        var fileName = file.name;
        return {
          id: "".concat(name, "-").concat(INDEX++),
          name: fileName,
          value: file
        };
      })));
      var isAcceptable = dataRejections.length === 0;
      if (_this._isMounted) {
        _this.setState({
          files: files
        });
      }
      if (onChange) {
        return onChange({
          currentTarget: {
            id: id,
            name: name,
            value: files
          }
        }, isAcceptable);
      }
    });
    (0, _defineProperty2.default)(_this, "handleClick", function (event /*: SyntheticEvent<HTMLLinkElement>*/) {
      event.stopPropagation();
    });
    (0, _defineProperty2.default)(_this, "handleDelete", function (event /*: SyntheticEvent<HTMLDivElement>*/, fileId /*: string*/) {
      event.stopPropagation();
      var _this$props2 = _this.props,
        disabled = _this$props2.disabled,
        id = _this$props2.id,
        ref = _this$props2.inputRef,
        name = _this$props2.name,
        onChange = _this$props2.onChange;
      if (disabled) {
        return;
      }
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object' && ref.current.fileInputEl && (0, _typeof2.default)(ref.current.fileInputEl) === 'object') {
        // The recommended way to clear an HTML file input
        // https://stackoverflow.com/a/24608023
        // For modern browsers
        ref.current.fileInputEl.value = '';

        // For older browsers and testing library
        if (ref.current.fileInputEl.files && ref.current.fileInputEl.files.length && ref.current.fileInputEl.parentNode) {
          ref.current.fileInputEl.parentNode.replaceChild(ref.current.fileInputEl.cloneNode(true), ref.current.fileInputEl);
        }
      }
      var prevFiles = _this.state.files;
      var files = prevFiles.filter(function (_ref) {
        var id = _ref.id;
        return id !== fileId;
      });
      if (_this._isMounted) {
        _this.setState({
          files: files
        });
      }
      if (onChange) {
        return onChange({
          currentTarget: {
            id: id,
            name: name,
            value: files
          }
        });
      }
    });
    return _this;
  }
  (0, _inherits2.default)(FileInput, _PureComponent);
  return (0, _createClass2.default)(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      var _this$props3 = this.props,
        ref = _this$props3.inputRef,
        intl = _this$props3.intl,
        loading = _this$props3.loading,
        setLoadingState = _this$props3.setLoadingState;
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object' && ref.current.fileInputEl && (0, _typeof2.default)(ref.current.fileInputEl) === 'object' && typeof ref.current.fileInputEl.setCustomValidity === 'function') {
        ref.current.fileInputEl.setCustomValidity(loading ? intl.formatMessage(definedMessages.loading) : '');
      }
      if (setLoadingState) {
        setLoadingState(loading);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        files = _this$props4.files,
        ref = _this$props4.inputRef,
        intl = _this$props4.intl,
        loading = _this$props4.loading,
        setLoadingState = _this$props4.setLoadingState;
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object' && ref.current.fileInputEl && (0, _typeof2.default)(ref.current.fileInputEl) === 'object' && typeof ref.current.fileInputEl.setCustomValidity === 'function') {
        ref.current.fileInputEl.setCustomValidity(loading ? intl.formatMessage(definedMessages.loading) : '');
      }
      if (setLoadingState && loading !== prevProps.loading) {
        setLoadingState(loading);
      }
      if (Array.isArray(files) && files !== prevProps.files) {
        this.setState({
          files: files
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      var _this$props5 = this.props,
        ref = _this$props5.inputRef,
        intl = _this$props5.intl,
        loading = _this$props5.loading,
        setLoadingState = _this$props5.setLoadingState;
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object' && ref.current.fileInputEl && (0, _typeof2.default)(ref.current.fileInputEl) === 'object' && typeof ref.current.fileInputEl.setCustomValidity === 'function') {
        ref.current.fileInputEl.setCustomValidity(loading ? intl.formatMessage(definedMessages.loading) : '');
      }
      if (setLoadingState) {
        setLoadingState(loading);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        accept = _this$props6.accept,
        autoFocus = _this$props6.autoFocus,
        classes = _this$props6.classes,
        className = _this$props6.className,
        defaultValue = _this$props6.defaultValue,
        disabled = _this$props6.disabled,
        disabledClassName = _this$props6.disabledClassName,
        displayErrors = _this$props6.displayErrors,
        embedded = _this$props6.embedded,
        filename = _this$props6.filename,
        filesProps = _this$props6.files,
        hasError = _this$props6.hasError,
        hasRequired = _this$props6.hasRequired,
        hasSuccess = _this$props6.hasSuccess,
        hasValidation = _this$props6.hasValidation,
        inputClassName = _this$props6.inputClassName,
        ref = _this$props6.inputRef,
        intl = _this$props6.intl,
        loading = _this$props6.loading,
        maxFileSize = _this$props6.maxFileSize,
        multiple = _this$props6.multiple,
        name = _this$props6.name,
        onBlur = _this$props6.onBlur,
        onChange = _this$props6.onChange,
        placeholder = _this$props6.placeholder,
        readOnly = _this$props6.readOnly,
        readOnlyClassName = _this$props6.readOnlyClassName,
        required = _this$props6.required,
        setDisplayErrorsState = _this$props6.setDisplayErrorsState,
        setLoadingState = _this$props6.setLoadingState,
        theme = _this$props6.theme,
        title = _this$props6.title,
        type = _this$props6.type,
        url = _this$props6.url,
        props = (0, _objectWithoutProperties2.default)(_this$props6, _excluded);
      var files = this.state.files;
      var hasValue = (defaultValue && typeof defaultValue === 'string' || files && files.length > 0) && !hasError;
      var isRequired = required && !hasValue;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        "data-testid": name || 'file-input',
        tabIndex: "-1",
        title: title
      }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
        activeClassName: classes.inputFocus,
        className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.success, hasSuccess || displayErrors && !isRequired), classes.error, hasError || displayErrors && isRequired), classes.embedded, embedded), inputClassName),
        "data-id": "".concat(DISPLAY_NAME, "__control"),
        "data-testid": name ? "".concat(name, "-dropzone") : 'file-input-dropzone',
        disabled: disabled || readOnly,
        disabledClassName: (0, _classnames.default)(classes.disabled, disabledClassName, _objectSpread((0, _defineProperty2.default)({}, classes.readOnly, readOnly), readOnlyClassName ? (0, _defineProperty2.default)({}, readOnlyClassName, readOnly) : {})),
        inputProps: _objectSpread({
          'data-name': name,
          disabled: disabled,
          readOnly: readOnly,
          style: _mixins.default.visuallyHidden
        }, props),
        maxSize: maxFileSize,
        onDrop: this.handleChange,
        preventDropOnDocument: false,
        accept: accept,
        multiple: multiple,
        readOnly: readOnly,
        ref: ref
      }, /*#__PURE__*/_react.default.createElement(_attach.ReactComponent, {
        className: classes.icon,
        "data-id": "".concat(DISPLAY_NAME, "__icon")
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.embeddedContainer, embedded))
      }, loading && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.placeholder, (0, _defineProperty2.default)({}, classes.embeddedItem, embedded)),
        "data-id": "".concat(DISPLAY_NAME, "__placeholder")
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, messages.loading)), !hasValue && !loading && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.placeholder, (0, _defineProperty2.default)({}, classes.embeddedItem, embedded)),
        "data-id": "".concat(DISPLAY_NAME, "__placeholder")
      }, placeholder ? /*#__PURE__*/_react.default.createElement("span", null, placeholder) : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        defaultMessage: "No file chosen",
        description: "File input placeholder",
        id: "file.placeholder"
      })), hasValue && !loading && files.map(function (_ref3, index) {
        var id = _ref3.id,
          name = _ref3.name,
          value = _ref3.value;
        var preview = value.preview;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "".concat(id, "-").concat(index),
          className: (0, _classnames.default)(classes.value, (0, _defineProperty2.default)({}, classes.embeddedItem, embedded))
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: classes.label,
          "data-id": "".concat(DISPLAY_NAME, "__multi-value__label"),
          download: name,
          href: preview,
          onClick: _this2.handleClick,
          title: name
        }, name), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.remove,
          "data-id": "".concat(DISPLAY_NAME, "__remove"),
          onClick: function onClick(event) {
            return _this2.handleDelete(event, id);
          },
          onKeyDown: function onKeyDown(event) {
            if ((0, _keycode.default)(event) === 'enter') {
              return _this2.handleDelete(event, id);
            }
          },
          role: "button",
          tabIndex: disabled ? -1 : 0
        }, /*#__PURE__*/_react.default.createElement("svg", {
          "aria-hidden": "true",
          focusable: "false",
          height: "14",
          viewBox: "0 0 20 20",
          width: "14"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }))));
      }))), /*#__PURE__*/_react.default.createElement("input", {
        className: classes.inputShadow,
        "data-name": name,
        onChange: NOOP,
        value: defaultValue && typeof defaultValue === 'string' ? defaultValue : '',
        name: name,
        required: required
      }), !hasError && !hasValue && !loading && /*#__PURE__*/_react.default.createElement(_InputRequired.default, {
        className: classes.required,
        disabled: disabled,
        embedded: embedded,
        hasRequired: hasRequired,
        readOnly: readOnly,
        required: required
      }), hasError && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.errorMessage,
        "data-id": "".concat(DISPLAY_NAME, "__indicators")
      }, /*#__PURE__*/_react.default.createElement(_error.ReactComponent, {
        className: classes.errorIcon
      })));
    }
  }]);
}(_react.PureComponent); // TODO: Type props to component
(0, _defineProperty2.default)(FileInput, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(FileInput, "defaultProps", {
  autoComplete: 'off',
  autoFocus: false,
  disabled: false,
  displayErrors: false,
  embedded: false,
  filename: null,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  loading: false,
  multiple: false,
  readOnly: false,
  required: false,
  type: 'file',
  url: null
});
/*:: type EnhancedProps = Object;*/
var _default = exports.default = ((0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), _reactIntl.injectIntl, (0, _injectSheet.default)(Style), (0, _recompose.withProps)(function (_ref4) {
  var inputRef = _ref4.inputRef;
  return {
    inputRef: inputRef || (0, _react.createRef)()
  };
}))(FileInput) /*: ComponentType<EnhancedProps>*/);
//# sourceMappingURL=FileInput.js.map